export default __webpack_public_path__ + "static/SkillIndia-c2c0479ab7683e0ad47852984d2aab13.png";